import error from './decorators/error';

const ERRORS = {
  @error
  DuplicateActionTypeError(actionTypeName) {
    this.name = 'Duplicate Action Type';
    this.message = `There is more than one action named ${actionTypeName}! Class names must be unique.`;
  },

  @error
  RequiredActionNamespaceError() {
    this.name = 'Required Action Creator REDUX_NAMESPACE Missing';
    this.message = `All action creators require a string property called 'REDUX_NAMESPACE' on their parent scopes to
     help disambiguate between action creators of the same name in different modules!`;
  },

  @error
  IncorrectArgumentType(actualType, expectedType) {
    this.name = 'Invalid Argument Type';
    this.message = `Expected type ${expectedType} but was given ${actualType}.`;
  },
};

export default ERRORS;
